import Logger from './lib/logger';
import '@ungap/custom-elements';
import './partials/SvgIcon';
import './partials/TrayBuilderMain';
import './partials/TrayBuilderTouch';
import './partials/DimensionalSelect';
import './partials/InsertButton';
import './partials/MessageBar';
import './partials/ToggleSlider';
import './partials/SubtotalBar';
import './partials/SvgGrid';
import './partials/SvgInsertsContainer';
import './partials/BuilderModal';
import './partials/CustomInsertModal';
import './partials/RingCushionInsertModal';
import './partials/PricingModal';
import './partials/PricingEstimate';

const NAME = 'Custom Tray Builder';

function init() {
  Logger.info(`${NAME} > init`);
  setTimeout(() => {
    const loadingAnim = document.querySelector('loading-anim') as HTMLElement;
    if (loadingAnim) loadingAnim.dataset.loading = 'false';
  }, 1000);
  
}

init();